var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNobodyBeatsUs24 = function SvgNobodyBeatsUs24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.326 10.55a.176.176 0 0 1 .173.193 1.6 1.6 0 0 1-.37.971 1.41 1.41 0 0 1-1.129.438h-2.325a.174.174 0 0 1-.175-.173v-.575a.169.169 0 0 1 .123-.164.874.874 0 0 0 .4-.271 1.034 1.034 0 0 0 .232-.659 1.362 1.362 0 0 0-.064-.374h-.494a.175.175 0 0 1-.175-.175v-.403a.175.175 0 0 1 .175-.175h.219a1.779 1.779 0 0 1-.077-.518c0-.225.043-.448.13-.657.081-.198.204-.377.358-.527.158-.153.344-.272.55-.352a2.021 2.021 0 0 1 1.786.182c.24.165.429.392.55.656a.177.177 0 0 1-.103.243l-.523.17a.168.168 0 0 1-.201-.074.9.9 0 0 0-.28-.306.96.96 0 0 0-.54-.151.831.831 0 0 0-.622.234.852.852 0 0 0-.219.615c.006.165.038.328.096.483h1.582a.173.173 0 0 1 .173.175v.403a.172.172 0 0 1-.173.175h-1.326a1.955 1.955 0 0 1-.065.929.768.768 0 0 1-.3.396h1.29c.42 0 .657-.186.699-.557a.17.17 0 0 1 .17-.154l.455.003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.985 11h-5.08a2.435 2.435 0 0 0-.872.152 4.319 4.319 0 0 0-1.779 1.243 1.176 1.176 0 0 0-.254.752v4.805c0 .138.024.274.071.402.048.127.117.243.205.34a.942.942 0 0 0 .307.227c.115.053.238.08.362.079h13.11a.9.9 0 0 0 .668-.307c.177-.196.277-.463.277-.74v-2.39",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14h2.613",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H6.917a1.683 1.683 0 0 0-1.12.413C4.239 8.816 4 11 4 11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19c-.099-1.002-.439-1.941-.973-2.69a.781.781 0 0 0-.598-.31H8.568a.786.786 0 0 0-.597.31C7.437 17.06 7.098 18 7 19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.036v1.158c0 .106-.02.211-.057.31a.814.814 0 0 1-.163.261.747.747 0 0 1-.244.175.702.702 0 0 1-.287.06H4.748a.698.698 0 0 1-.287-.06.743.743 0 0 1-.243-.175.81.81 0 0 1-.162-.262.857.857 0 0 1-.056-.309V19m13 0v1.272a.712.712 0 0 1-.22.516.749.749 0 0 1-.53.212h-1.502a.761.761 0 0 1-.53-.212.724.724 0 0 1-.218-.516V19M3.636 11H2.364C2.163 11 2 10.776 2 10.5s.163-.5.364-.5h1.272c.201 0 .364.224.364.5s-.163.5-.364.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNobodyBeatsUs24;